document.addEventListener("alpine:init", () => {

    Alpine.data("tagSlider", () => ({
        isPan: false,
        panStarted: false,
        startX: 0,
        offsetX: 0,
        left: 0,
        coverWidth: 0,
        clickEnabled: true,
        pointerStart: 0,

        setSlider() {
            this.$refs.container.style.height =
                this.$refs.wrapper.offsetHeight + 2 + "px";
            this.coverWidth =
                (this.$refs.slider.offsetWidth -
                    this.$refs.container.offsetWidth) /
                2;

            if (
                this.$refs.container.offsetWidth >=
                this.$refs.wrapper.offsetWidth
            ) {
                this.left = 0;
                return;
            }
        },
        panStart(ev) {
            this.isPan = true;
            this.panStarted = true;
            let clientX = ev.clientX || ev.changedTouches[0].clientX;
            this.pointerStart = clientX;
            this.startX = clientX - this.$refs.container.offsetLeft - this.left;
        },
        panEnd(ev) {
            this.panStarted = false;
            this.isPan = false;
            this.clickEnabled = true;
            let clientX = ev.clientX || ev.changedTouches[0].clientX;
        },
        panMove(ev) {
            if (
                this.$refs.container.offsetWidth >=
                this.$refs.wrapper.offsetWidth
            ) {
                this.left = 0;
                return;
            }
            let clientX = ev.clientX || ev.changedTouches[0].clientX;
            this.isPan =
                this.panStarted && Math.abs(this.pointerStart - clientX) > 10;
            if (!this.isPan) return;
            this.clickEnabled = false;
            this.left = clientX - this.$refs.container.offsetLeft - this.startX;
            this.left = this.left > 0 ? 0 : this.left;
            this.left =
                this.left <
                -this.$refs.wrapper.offsetWidth +
                    this.$refs.container.offsetWidth
                    ? -this.$refs.wrapper.offsetWidth +
                    this.$refs.container.offsetWidth
                    : this.left;
        },
        select(id) {
            if (!this.clickEnabled) return;
            this.$wire.select(id);
            this.setSlider();
        },
        removeFilter(tag, value) {
            if (!this.clickEnabled) return;
            this.$wire.dispatch("remove-filter", [tag, value]);
            this.setSlider();
        },
        selectDisplay(id) {
            if (!this.clickEnabled) return;
            this.$wire.selectDisplay(id);
            this.setSlider();
        },
        wrapperEvents: {
            [":style"]() {
                return `left: ${this.left}px`;
            },
            ["@mousedown.prevent"](ev) {
                this.panStart(ev);
            },
            ["@mouseup.prevent"](ev) {
                ev.preventDefault();

                this.panEnd(ev);
            },
            ["@mouseup.outside"](ev) {
                this.panEnd(ev);
            },
            ["@mousemove.prevent"](ev) {
                this.panMove(ev);
            },
            ["@touchstart.passive"](ev) {
                this.panStart(ev);
            },
            ["@touchend.prevent"](ev) {
                this.panEnd(ev);
            },
            ["@touchmove.passive"](ev) {
                this.panMove(ev);
            },
            ["@resizeswipers.window"](ev) {
                this.setSlider();
            },
            ["@resize.window"](ev) {
                this.setSlider();
            },
        },

        init() {
            this.$nextTick(() => {
                this.setSlider();
            });
        },
    }));


    Alpine.data("cardListing", (mobile = false) => ({
        swiper: null,
        next: true,
        prev: false,
        initSwiper() {
            Swiper.use([Navigation]);
            var _this = this;
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }
            this.swiper = new Swiper(this.$refs.swiper, {
                speed: 300,
                slidesPerView: 1,
                lazy: true,
                navigation: {
                    nextEl: this.$refs.nextInside,
                    prevEl: this.$refs.prevInside,
                },
                on: {
                    slideChange: function () {
                        _this.checkArrows();
                    },
                },
            });
            this.checkArrows();
        },
        checkArrows() {
            this.prev = this.swiper.realIndex !== 0;
            this.next = this.swiper.realIndex !== this.swiper.slides.length - 1;
        },
        playVideo() {
            let curSlide = this.swiper.slides[this.swiper.realIndex];
            if (
                typeof curSlide !== "undefined" &&
                curSlide.querySelector("video")
            ) {
                curSlide.querySelector("video").play();
                curSlide.querySelector("video").classList.remove("hidden");
            }
        },
        stopVideo() {
            let curSlide = this.swiper.slides[this.swiper.realIndex];
            if (
                typeof curSlide !== "undefined" &&
                curSlide.querySelector("video") &&
                curSlide.querySelector("video").src !== ""
            ) {
                curSlide.querySelector("video").pause();
            }
        },

        cardEvents: {
            ["@mouseenter"]() {
                if (!mobile) {
                    this.playVideo();
                }
            },
            ["@mouseleave"]() {
                if (!mobile) {
                    this.stopVideo();
                }
            },
        },

        prevInside: {
            ["@click.prevent.stop"]() {
                this.swiper.slidePrev();
            },
            ["x-show"]() {
                return this.prev;
            },
        },
        nextInside: {
            ["@click.prevent.stop"]() {
                this.swiper.slideNext();
            },
            ["x-show"]() {
                return this.next;
            },
        },

        init() {
            this.initSwiper();
        },
    }));

    Alpine.data("cardListingRefactor", () => ({
        playVideo() {
            if (this.$refs.player) {
                this.$refs.player.play();
            }
        },
        stopVideo() {
            if (this.$refs.player && this.$refs.player.src !== "") {
                this.$refs.player.pause();
            }
        },

        cardEvents: {
            ["@mouseenter"]() {
                    this.playVideo();
            },
            ["@mouseleave"]() {
                    this.stopVideo();
            },
        },
    }));

    Alpine.data("thumbSlider", () => ({
        swiper: null,
        initSwiper() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }
            var _this = this;
            this.swiper = new Swiper(this.$refs.swiper, {
                modules: [Pagination],
                speed: 300,
                pagination: {
                    el: this.$refs.pagination,
                    clickable: true,
                },
                on: {
                    slideChange: function () {
                        _this.loadSlide();
                    },
                },
            });
            _this.loadSlide();
        },
        loadSlide() {
            let curSlide = this.swiper.slides[this.swiper.realIndex];
            if (
                curSlide &&
                curSlide.querySelector("img") &&
                curSlide.querySelector("img").src == ""
            ) {
                curSlide.querySelector("img").src =
                    curSlide.querySelector("img").dataset.src;
            }
        },
        init() {
            this.initSwiper();
        },
    }));

    Alpine.data("socialSwiper", () => ({
        swiper: null,
        currentSlide: 0,

        initSwiper() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }
            this.swiper = new Swiper(this.$refs.swiper, {
                modules: [Navigation],
                slidesPerView: "auto",
                spaceBetween: 8,
                navigation: {
                    nextEl: this.$refs.next,
                    prevEl: this.$refs.prev,
                },
                on: {
                    slideChange: () => {
                        this.currentSlide = this.swiper.realIndex;
                    },
                },
            });
        },
        nextSlide() {
            this.swiper.slideNext();
        },
        prevSlide() {
            this.swiper.slidePrev();
        },

        prevBtn: {
            ["x-show"]() {
                return this.currentSlide > 0;
            },
        },

        nextBtn: {
            ["x-show"]() {
                return (
                    this.currentSlide < this.$refs.wrapper.children.length - 1
                );
            },
        },

        init() {
            this.initSwiper();
        },
    }));

    Alpine.data("previewChat", (active = false, unread = 0, when = "") => ({
        active: active,
        unread: unread,
        when: when,
        ago: "",
        interval: null,
        initPreview() {
            this.recalculateWhen();
            this.interval = setInterval(() => {
                this.recalculateWhen();
            }, 1000);
        },
        recalculateWhen() {
            if (this.when === "" || this.when === null) return;
            this.ago = formatDistance(
                toDate(parse(this.when, "t", new Date())),
                new Date(),
                {
                    locale: DateFnsLocaleIt,
                    addSuffix: true,
                },
            );
        },
        init() {
            this.initPreview();
        },
        destroy() {
            clearInterval(this.interval);
        },
        unreadbadge: {
            ["x-show"]() {
                return this.unread > 0;
            },
        },
        agobadge: {
            ["x-html"]() {
                return this.ago;
            },
        },
    }));

    Alpine.data("captcha", () => ({
        interval: null,
        async setToken() {
            const action = this.$el.getAttribute("data-action");
            const siteKey = this.$el.getAttribute("data-sitekey");

            try {
                const token = await window.grecaptcha.enterprise.execute(
                    siteKey,
                    { action },
                );
                this.$el.value = token;
                this.$el.dispatchEvent(new Event("input"));
            } catch (error) {
                console.warn(error.message);
            }
        },
        async loadToken() {
            try {
                await grecaptcha.enterprise.ready(async () => {
                    this.setToken();
                });
            } catch (err) {
                console.warn("recaptcha", err.message);
            }
        },
        init() {
            this.loadToken();

            this.interval = null;
            this.interval = setInterval(() => {
                this.setToken();
            }, 90 * 1000);
        },
    }));

    Alpine.data("iubenda", (disable = false) => ({
        onSubmit(event) {
            const customPrivacyPolicyVersionElement = this.$el.querySelector(
                "[data-iubenda-privacy-policy-version]",
            );
            if (!customPrivacyPolicyVersionElement) {
                console.log("missing privacy policy version");
                return;
            }

            try {
                _iub.cons_instructions.push([
                    "submit",
                    {
                        writeOnLocalStorage: false,
                        form: {
                            selector: this.$el,
                        },
                        consent: {
                            legal_notices: [
                                {
                                    identifier: "privacy_policy_custom",
                                    version:
                                        customPrivacyPolicyVersionElement.value,
                                },
                                {
                                    identifier: "cookie_policy",
                                },
                                {
                                    identifier: "terms",
                                },
                            ],
                        },
                    },
                    {
                        success: (response) => {
                            console.log("success");
                        },
                        error: (response) => {
                            console.error(response);
                        },
                    },
                ]);
            } catch (err) {
                console.error(err);
            }
        },
    }));

});

window.scrollToFirstOccurrence = function (className) {
    const element = document.querySelector(`.${className}`).parentElement
        .parentElement;
    if (element) {
        element.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    } else {
        console.log(`Nessun elemento trovato`);
    }
};

window.onload = function () {
    dispatchEvent(new CustomEvent("resizeswipers"));
};

window.onresize = function () {
    dispatchEvent(new CustomEvent("resizeswipers"));
};

Livewire.hook("morph.updated", ({ el, component }) => {
    window.lazyLoadInstance.update();

    // const fbVideos = document.querySelectorAll(".fb-video");
    // if (fbVideos.length > 0) {
    //     FB.XFBML.parse();
    // }

    dispatchEvent(new CustomEvent("fb-video-init"));
});
